<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row flex-grow-1">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3">
              Confira as demais startups do seu batch que estão participando do
              programa de aceleração Stars.
            </p>
          </div>
          <div class="col-12 text-right mb-4">
            <router-link
              v-if="batch"
              :to="`/startup/batches/${batch.id}/acompanhamento`"
              class="btn-link font-weight-normal text-white"
              ><badge type="info" class="bg-white"
                ><i class="fas fa-award mr-1"></i> Batch {{ batch.name }}</badge
              >
            </router-link>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck vld-parent" ref="startups_list">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="bs in batch.startups"
              :key="bs.startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="bs.startup.logo.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-8 pt-0 pb-0">
                  <h2 class="card-title text-orange mb-1">
                    {{ bs.startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ bs.startup.city || "..." }},
                      {{ bs.startup.state || "..." }}
                    </div>
                    <div class="h5 mt-2">
                      <badge type="info">
                        {{ bs.startup.sector }}
                      </badge>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center pb-1">
                  <p class="ml-2 text-sm text-break">
                    <i class="fas fa-quote-left mr-1"></i
                    ><span class="text-muted">{{
                      bs.startup.one_sentence_pitch
                    }}</span
                    ><i class="fas fa-quote-right ml-1"></i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Não existem startups cadastradas no batch até o momento.</badge
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "startups_list_batch",
  data() {
    return {
      batch: "",
      empty: false,
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.startups_list,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    this.loadStartups();
    loader.hide();
  },
  methods: {
    async loadStartups() {
      try {
        const { data } = await api.get(
          `/startup-batches/${this.$route.params.id}`
        );
        if (data) this.batch = data;
        if (data.startups) {
          const defaultLogoPath = "/img/pages/default_logo.png";
          data.startups.forEach((bs) => {
            if (!bs.startup.logo) bs.startup.logo = { url: defaultLogoPath };
          });
        } else {
          this.empty = true;
        }
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as startups do batch"
        );
        this.$router.push("/startup/batches");
      }
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 140px;
  height: 140px;
  border-radius: 10%;
  margin: auto;
}
</style>
